import {post,get} from '../../libs/ajax.js';

export default {
    // 素材内容导出
    exportMaterial:(data,options) => {
        return post('/assist_tools/material_export', data, options);
    },

    // 基建数据导出
    infrastructureDataExport:(data,options) => {
        return post('/assist_tools/infrastructure_data_export', data, options);
    },
}
